var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchApartments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M16.089 3.481a8.916 8.916 0 01.599 11.946l4.182 4.183-1.26 1.26-4.184-4.182a8.916 8.916 0 11.663-13.207zm-1.261 1.261A7.132 7.132 0 104.742 14.828 7.132 7.132 0 0014.828 4.742z"
  })));
}

export default __webpack_public_path__ + "c1111e40891bd58176e4557382cfbcf0.svg";
export { SvgSearchApartments as ReactComponent };